
import { apiCall, logOut } from "@/lib/api";
import { apiURL } from "@/lib/constants";
import Popup from "../Popup.vue";
import { Component, MixedVue, mixins } from "@/vue";
import { LegalTerm } from "@/lib/types/LegalTerm";
import { gettersInstance } from "@/lib/util";
import { Watch } from "vue-property-decorator";
import { User } from "@/lib/types/User";

@Component({
  name: "PrivacyPolicyPopup",
  components: { Popup },
})
export default class PrivacyPolicyPopup extends mixins(MixedVue, gettersInstance(["user"])) {
  static components: {
    Popup: typeof Popup;
  };

  privacyPolicy: LegalTerm = null;
  generaltos: LegalTerm = null;
  loadingLegalData: boolean = true;
  marketingTick: boolean = false;

  created() {
    this.loadLegalData();
  }

  get latestPrivacy() {
    return this.user.privacy;
  }

  get latestTOS() {
    return this.user.generaltos;
  }

  get showPopup() {
    return this.user && this.user.id && (!this.latestPrivacy || !this.latestTOS) && this.$route.name != "oauth";
  }

  get headingText() {
    return this.$gettext("<strong>We need your consent</strong> to continue using OGOR");
  }

  @Watch("showPopup")
  showPopupChanged() {
    this.loadLegalData();
  }

  async loadLegalData() {
    if (!this.showPopup) return;
    this.loadingLegalData = true;
    if (!this.latestPrivacy) {
      this.privacyPolicy = await apiCall("GET", `${apiURL}/legal/privacy/`);
    }
    if (!this.latestTOS) {
      this.generaltos = await apiCall("GET", `${apiURL}/legal/generaltos/`);
    }
    this.loadingLegalData = false;
  }

  startingWithText(date: string) {
    return this.$gettextInterpolate(this.$gettext("Starting with <strong>%{ date }</strong>, the following come into force:"), {
      date: this.dateFormated(date),
    });
  }

  dateFormated(date: string) {
    return new Date(date).toLocaleDateString(this.$language.current, {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }

  agreeTerms() {
    let marketingData = this.marketingTick ? { marketing: true } : {};
    apiCall<User>(
      "PATCH",
      `${apiURL}/auth/user/`,
      {},
      {
        privacy: true,
        generaltos: true,
        ...marketingData,
      }
    )
      .then((user) => {
        this.$store.commit("setCurrentUser", user);
        this.notify({
          type: "success",
          text: this.$gettext("Terms accepted."),
        });
        window.location.reload();
      })
      .catch(() => {
        this.notify({
          type: "warning",
          text: this.$gettext("Something went wrong."),
        });
      });
  }

  async signOut() {
    await logOut();
    this.$store.commit("clearUser");
    await this.$store.dispatch("clearState");
  }
}
